export const ACTION_TYPES = {
	SET_USER: 'SET_USER',
	UPDATE_USER_INFO: 'UPDATE_USER_INFO',
	REMOVE_USER: 'REMOVE_USER',
}